export default __webpack_public_path__ + "assets/images/94b4fca7ef9228e9581ad650d9b874ad.png";